"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUnscopeUser = void 0;
var createErrorAction_1 = require("../actionCreators/createErrorAction");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var dispatchUpdateUnscopeUser_1 = require("../state/dispatch/dispatchUpdateUnscopeUser");
var description = 'useUpdateUnscopeUser';
var useUpdateUnscopeUser = function (_a) {
    var parentDescription = _a.parentDescription, onSuccess = _a.onSuccess;
    var dispatch = (0, react_redux_1.useDispatch)();
    var useDescription = "".concat(parentDescription, " - ").concat(description, " ");
    var currentUserId = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUserId || '';
    });
    var hasUnscopeUser = (0, react_redux_2.useSelector)(function (state) {
        var _a;
        return !!((_a = state.currentUnscopeUser) === null || _a === void 0 ? void 0 : _a.created);
    });
    var updateUnscopeUser = (0, react_1.useCallback)(function (_a) {
        var unscopeUser = _a.unscopeUser;
        if (currentUserId) {
            (0, dispatchUpdateUnscopeUser_1.dispatchUpdateUnscopeUser)({
                userId: currentUserId,
                values: unscopeUser,
                parentDescription: useDescription,
                dispatch: dispatch,
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
        else {
            dispatch((0, createErrorAction_1.createErrorAction)({
                description: "".concat(useDescription, " - missing data"),
            }));
        }
    }, [currentUserId, dispatch, useDescription, onSuccess]);
    return {
        updateUnscopeUser: updateUnscopeUser,
        updateUnscopeUserReady: !!currentUserId && hasUnscopeUser,
    };
};
exports.useUpdateUnscopeUser = useUpdateUnscopeUser;
